import { _err, _log } from "./logger";
export const IS_ANDROID =
  navigator.userAgent.toLowerCase().indexOf("android") > -1;
export const dataURLtoBase64 = (dataURL) => {
  return dataURL.split(";base64,")[1];
};

export const toBase64 = (file) => {
  _log("toBase64", file);
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const getImageDimansion = (file) => {
  return new Promise((resolve, reject) => {
    const uri = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(uri);
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = () => {
      URL.revokeObjectURL(uri);
      reject();
    };
    img.src = uri;
  });
};

export const base64Resize = (base64, options) => {
  return new Promise((resolve, reject) => {
    const { width, height, width_o, height_o, type, quality, ratio, filters } =
      options;

    const img = new Image();
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    img.onload = () => {
      canvas.width = width;
      if (ratio) {
        canvas.height = ratioHeight(img.width, img.height, width);
      } else {
        canvas.height = height;
      }
      _log("base64Resize", canvas.width, canvas.height);
      if (filters) {
        canvas.getContext("2d").filter = filters;
      }
      _log("filters", filters);
      context.drawImage(img, 0, 0, canvas.width, canvas.height);
      if (quality) {
        const q = quality / 100;
        _log("quality", q);
        const dataURL = canvas.toDataURL("image/" + type, q);
        resolve(dataURL);
      } else {
        const dataURL = canvas.toDataURL("image/" + type);
        resolve(dataURL);
      }
    };
    img.onerror = () => {
      reject();
    };
    img.src = base64;
  });
};

export const base64ResizeToCanvas = (img, options) => {
  return new Promise((resolve, reject) => {
    const { width, height, width_o, height_o, type, quality, ratio, filters } =
      options;

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.width = width;
    canvas.height = height;
    _log("base64ResizeToCanvas", canvas.width, canvas.height);
    if (filters) {
      canvas.getContext("2d").filter = filters;
    }
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
    resolve(canvas);
  });
};

export const ratioHeight = (widthOr, heightOr, widthNew) => {
  const ratio = widthOr / heightOr;
  const heightNew = widthNew / ratio;
  return Math.trunc(heightNew);
};

export const ratioW = (widthOr, heightOr, widthNew) => {
  const ratio = widthOr / heightOr;
  const heightNew = widthNew / ratio;
  return Math.trunc(heightNew);
};

export const ratioH = (widthOr, heightOr, heightNew) => {
  const ratio = heightOr / widthOr;
  const widthNew = heightNew / ratio;
  return Math.trunc(widthNew);
};

export const resizeImage = async (file, options) => {
  _log("resizeImage", options);
  const b64 = await toBase64(file);
  const b64R = await base64Resize(b64, options);
  return b64R;
};

// export const cl = () => {
//     const na = new Int8Array([118, 105, 101, 119, 101, 114])
//     const wlhn = new Int8Array([119, 105, 110, 100, 111, 119, 46, 108, 111, 99, 97, 116, 105, 111, 110, 46, 104, 111, 115, 116, 110, 97, 109, 101])
//     let utf8decoder = new TextDecoder();
//     const first = utf8decoder.decode(na)
//     const second = eval(utf8decoder.decode(wlhn))
//     return first && second && (second.includes(first))
// }

export const getImage = () => {
  return new Promise((res) => {
    const image = new Image();
    image.onload = function () {
      res(this);
    };
    image.src = src;
  });
};

// export async function cropImages(
//   image,
//   cropData,
//   myTensor,
//   filters,
//   imageType,
//   imageName
// ) {
//   const images = [];
//   if (cropData.length > 0) {
//     if (!myTensor) {
//       myTensor = tf.browser.fromPixels(image);
//     }
//     if (filters) {
//       //const img = await getImage();

//       for await (let cd of cropData) {
//         const canvasCrop = document.createElement('canvas');
//         // canvasCrop.style.position = "fixed";
//         // canvasCrop.style.top = 0;
//         // canvasCrop.style.left = 0;
//         // canvasCrop.style.zIndex = 88888888;
//         // document.body.appendChild(canvasCrop);
//         // _log("cd", cd);

//         canvasCrop.width = cd.width;
//         canvasCrop.height = cd.height;
//         const ctx = canvasCrop.getContext('2d');
//         ctx.filter = filters;
//         ctx.drawImage(
//           image,
//           cd.startX + 4,
//           cd.startY + 4,
//           cd.width - 8,
//           cd.height - 8,
//           0,
//           0,
//           cd.width - 8,
//           cd.height - 8
//         );

//         const type = 'image/' + imageType;
//         _log('cropImages() filters', filters);

//         const _image = canvasCrop.toDataURL(type);

//         if (_image) {
//           images.push(_image);
//         }
//       }
//     } else {
//       const canvasCrop = document.createElement('canvas');

//       for await (let cd of cropData) {
//         const startingPoint = [cd.startY + 4, cd.startX + 4, 0];
//         const newSize = [cd.height - 8, cd.width - 8, 3];
//         const cropped = tf.slice(myTensor, startingPoint, newSize);
//         await tf.browser.toPixels(cropped, canvasCrop);
//         cropped.dispose();
//         const type = 'image/' + imageType;
//         _log('cropImages()', filters);

//         const image = canvasCrop.toDataURL(type);

//         if (image) {
//           images.push(image);
//         }
//       }
//     }
//   }
//   _log('myTensor dispose');
//   _log('images', images);
//   download(images, imageType, imageName);
// }

// async function download(images, imageType, imageName) {
//   if (images || images.length > 0) {
//     if (images.length === 1) {
//       const type = 'image/' + imageType;
//       const link = document.createElement('a');
//       link.setAttribute('href', images[0].replace(type, 'image/octet-stream'));
//       const _fileName = `${imageName}.${imageType}`;
//       link.setAttribute('download', _fileName);
//       link.click();
//     }
//     if (images.length > 1) {
//       const JSZip = await import('jszip');
//       const { saveAs } = await import('file-saver');
//       const zip = new JSZip.default();
//       for (const [i, image] of images.entries()) {
//         const _fileName = `${i + 1}_${imageName}.${imageType}`;
//         _log('_fileName', _fileName);
//         zip.file(_fileName, dataURLtoBase64(image), {
//           base64: true,
//         });
//       }

//       zip
//         .generateAsync({
//           type: 'blob',
//         })
//         .then(function (content) {
//           saveAs(content, imageName);
//         });
//     }
//   }
// }

export function randomNumber(min, max) {
  return Math.random() * (max - min) + min;
}

export function getRatio(srcWidth, srcHeight, maxWidth, maxHeight) {
  return Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
}

export const getMaxValue = (name) => {
  switch (name) {
    case "vignette":
      return 10;
    case "art":
      return 6;
    case "mirror":
      return 5;
    case "depth":
    case "enrich":
      return 1;
    case "graysepia":
      return 7;
    case "neon":
    case "flip":
      return 2;
    case "shape":
      return 3;
    case "sketch":
      return 2;
    case "effect":
      return 13;

    case "saturation":
    case "red":
    case "blue":
    case "green":
      return 20;

    case "edges":
      return 6;
    // case "oil":
    //     return 3;
    default:
      return 10;
  }
};

export const getStepValue = (name) => {
  if (name == "oil") return 2;
  else return 1;
};

const numbersArr = [10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];
export const reverseDigits = (num) => {
  return numbersArr[num];
};

export const dateToLocaleString = () => {
  return new Date().toLocaleString({
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });
};

export const cl = () => {
  const na = new Int8Array([
    105, 105, 109, 97, 103, 101, 116, 111, 111, 108, 46, 118, 101, 114, 99, 101,
    108, 46, 97, 112, 112,
  ]);
  const wlhn = new Int8Array([
    119, 105, 110, 100, 111, 119, 46, 108, 111, 99, 97, 116, 105, 111, 110, 46,
    104, 111, 115, 116, 110, 97, 109, 101,
  ]);
  let utf8decoder = new TextDecoder();
  const first = utf8decoder.decode(na);
  const second = eval(utf8decoder.decode(wlhn));
  return first && second && second === first;
};

export async function getScreenLock() {
  if ("wakeLock" in navigator) {
    let screenLock;
    try {
      screenLock = await navigator.wakeLock.request("screen");
      _log("screenLock");
    } catch (err) {
      _err(err.name, err.message);
    }
    return screenLock;
  }
}

export async function shareImage(img) {
  try {
    _log("shareImage", img);
    const ext = img.name.substring(
      img.name.lastIndexOf(".") + 1,
      img.name.lenght
    );
    if (!img.title) {
      img.title = "iimagetool.vercel.app";
    }
    _log("shareImage", img.title, ext);
    const filesArray = [await getFile(img.title, ext, img.url)];
    const shareData = {
      files: filesArray,
      text: "https://iimagetool.vercel.app",
      title: "iimagetool.vercel.app",
    };
    if (navigator.canShare(shareData)) {
      navigator.share(shareData);
    }
  } catch (error) {
    _err(error);
  }
}

async function getFile(title, ext, img) {
  const blob = await (await fetch(img)).blob();
  const file = new File([blob], `${title}.${ext}`, {
    type: blob.type,
    lastModified: new Date().getTime(),
  });
  return file;
}
